export const environment = {
  production: false,
  apiUrl: 'https://inseelidev.svengit.com/api/i4u',
  name: 'dev',
  pdfHost: 'https://inseelidev.svengit.com',
  useMockPhase2: false,
  // Voucher programme is stopped — the `vouchers` table is empty in every environment
  // and none was ever issued, so the input could only ever report "invalid". Hidden
  // rather than deleted so it can be switched back on without restoring code. The
  // server still validates, so a stale build cannot apply a discount either.
  enableVoucher: false,
};
